import {iosVhFix} from './utils/ios-vh-fix';
import {initModals} from './modules/modals/init-modals';
import {initUpload} from './modules/upload';
import {initPicker} from './modules/picker';
import {initAuth} from './modules/auth';
import {initPreview} from './modules/preview';

window.addEventListener('DOMContentLoaded', () => {

  iosVhFix();
  initUpload();
  initPicker();
  initAuth();
  initPreview();

  if (document.querySelector('.progress')) {
    setTimeout(() => {
      window.location.href = 'preview.html';
    }, 4000);
  }

  window.addEventListener('load', () => {
    initModals();

    if (window.location.hash) {
      window.modals.open(window.location.hash.slice(1));
    }
  });
});
